import React from 'react';
import Hero from '../components/Hero';
import EntrySituations from '../components/EntrySituations';
import Approach from '../components/Approach';
import Abgrenzung from '../components/Abgrenzung';
import ProblemSection from '../components/ProblemSection';
import ServiceModel from '../components/ServiceModel';
import InqaCoaching from '../components/InqaCoaching';
import BeforeAfter from '../components/BeforeAfter';
import Deliverables from '../components/Deliverables';
import FAQ from '../components/FAQ';
import SelfHelp from '../components/SelfHelp';
import CTA from '../components/CTA';

const HomePage = () => {
  return (
    <>
      <Hero />
      <EntrySituations />
      <Approach />
      <Abgrenzung />
      <ProblemSection />
      <ServiceModel />
      <InqaCoaching />
      <BeforeAfter />
      <Deliverables />
      <FAQ />
      <SelfHelp />
      <CTA />
    </>
  );
};

export default HomePage;